import * as z from "zod";

/** Authored with the question, never inferred from nearby answers or option order. */
export const QuestionBriefSchema = z.object({
  background: z.string().trim().min(1).max(1200),
  recommendation: z.string().trim().min(1).max(600).optional(),
  evidence: z.array(z.object({
    text: z.string().trim().min(1).max(800),
    url: z.string().url().max(2000).refine((value) => {
      const protocol = new URL(value).protocol;
      return protocol === "https:" || protocol === "http:";
    }).optional(),
  })).max(6).optional(),
});
export type QuestionBrief = z.infer<typeof QuestionBriefSchema>;
